import { FormControl } from "@angular/forms";

export class CustomFormControl extends FormControl {
    constructor(value: any, public displayName: string, validators?: any[]) {
      super(value, validators);
    }
  }